import { render, staticRenderFns } from "./RoomCBTViewInfo.vue?vue&type=template&id=506ee962&scoped=true&"
import script from "./RoomCBTViewInfo.vue?vue&type=script&lang=js&"
export * from "./RoomCBTViewInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoomCBTViewInfo.vue?vue&type=style&index=0&id=506ee962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ee962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506ee962')) {
      api.createRecord('506ee962', component.options)
    } else {
      api.reload('506ee962', component.options)
    }
    module.hot.accept("./RoomCBTViewInfo.vue?vue&type=template&id=506ee962&scoped=true&", function () {
      api.rerender('506ee962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTViewInfo.vue"
export default component.exports